import { push } from "connected-react-router";
import { sessionActions } from "../actions";
import { authProvider } from "./providers";
import { LOGIN, LOGOUT } from "./providers/requestType";

export const logIn = (loginDetails, token) => async (dispatch) => {
  const { account, password } = loginDetails;
  const qs = {
    access: token,
  };
  const response = await authProvider(LOGIN, {
    qs,
    body: {
      account,
      password: password,
    },
    json: true,
  });
  if (response.data.token) {
    localStorage.setItem("JwtToken", response.data.token);
    return dispatch({ type: sessionActions.LOGIN, token: response.data.token });
  } else throw Error();
};

export const logOut = () => async (dispatch) => {
  const response = await authProvider(LOGOUT);
  if (response.data.status === 1) {
    localStorage.removeItem("JwtToken");
    dispatch(push("/login"));
  }
};

export const roughLogOut = () => {
  localStorage.removeItem("JwtToken");
  window.location.href = "/login";
};
